import React from 'react';
import { Alert, Drawer, Empty, Spin } from 'antd';
import { Calendar, Mail, MapPin, Phone } from 'react-feather';
import { getContactSourceLabel } from '../../utils/guestContactSources';

const initials = (s = '') => s.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';
const dateLabel = (raw) => {
  if (!raw) return '—';
  const d = new Date(raw);
  return !Number.isNaN(d.getTime()) ? d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : String(raw);
};
const statusLabels = {
  checked_out: 'Completed stay', checked_in: 'Currently in-house',
  reserved: 'Reserved', cancelled: 'Cancelled',
};
const Detail = ({ label, value }) => <div><small>{label}</small><strong>{value || '—'}</strong></div>;
const GuestProfileModal = ({ visible, onClose, guest, loading, historicalStays = [], error }) => {
  const completed = Number(guest?.completed_stays) || 0;
  const status = guest?.in_house ? 'In-house' : completed >= 2 ? 'Returning guest' : completed === 1 ? 'First stay' : 'No completed stays';
  return <Drawer className="gcrm-drawer" title={<span className="gcrm-drawer-title">Guest profile</span>}
    placement="right" width={610} zIndex={30000} visible={visible} onClose={onClose} destroyOnClose>
    {guest && <>
      <div className="gcrm-profile-hero"><div className="gcrm-profile-avatar">{initials(guest.full_name)}</div><div>
        <h3>{guest.guest_title ? `${guest.guest_title} ` : ''}{guest.full_name}</h3>
        <p>Guest #{guest.guest_id} · {status}{guest.is_regular ? ' · Marked regular' : ''}</p>
      </div></div>
      <div className="gcrm-profile-kpis">
        <div><strong>{completed}</strong><span>Completed stays</span></div>
        <div><strong>{guest.in_house ? 'Yes' : 'No'}</strong><span>Currently in-house</span></div>
        <div><strong>{guest.upcoming ? 'Yes' : 'No'}</strong><span>Upcoming booking</span></div>
      </div>
      <section className="gcrm-profile-section"><h4>Contact & location</h4>
        <div className="gcrm-detail-grid">
          <Detail label="Phone number" value={guest.phone_no && <span><Phone size={12} style={{ marginRight: 6 }} />{guest.phone_no}</span>} />
          <Detail label="Email address" value={guest.email && <span><Mail size={12} style={{ marginRight: 6 }} />{guest.email}</span>} />
          <Detail label="Location" value={[guest.city, guest.state, guest.country].filter(Boolean).join(', ') || <MapPin size={12} />} />
          <Detail label="Nationality" value={guest.nationality} />
          <Detail label="Address" value={[guest.address, guest.zip_code].filter(Boolean).join(', ')} />
          <Detail label="Guest since" value={dateLabel(guest.created_at)} />
          <Detail label="Contact source" value={getContactSourceLabel(guest.contact_source_code)} />
        </div>
      </section>
      <section className="gcrm-profile-section"><h4>Personal details</h4>
        <div className="gcrm-detail-grid">
          <Detail label="Birthday" value={dateLabel(guest.date_of_birth)} />
          <Detail label="Wedding anniversary" value={dateLabel(guest.marriage_anniversary)} />
          <Detail label="Gender" value={guest.gender} />
          <Detail label="Last completed checkout" value={dateLabel(guest.last_stay)} />
        </div>
      </section>
      <section className="gcrm-profile-section"><h4><Calendar size={15} style={{ marginRight: 7, verticalAlign: 'middle' }} />Stay history</h4>
        {error && <Alert type="warning" showIcon message={error} style={{ marginBottom: 12 }} />}
        <Spin spinning={loading}>
          {!loading && !error && historicalStays.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No reservation history for this guest" />}
          {historicalStays.map(b => <div key={b.booking_id} className="gcrm-stay">
            <span className="gcrm-stay-dot" /><div>
              <strong>{statusLabels[b.status] || b.status || 'Booking'} · {b.booking_number || `#${b.booking_id}`}</strong>
              <small>{dateLabel(b.check_in_date)} – {dateLabel(b.check_out_date)}{b.booking_source ? ` · ${b.booking_source}` : ''}</small>
            </div>
          </div>)}
        </Spin>
      </section>
      <div className="gcrm-import-note">For guest privacy, identity documents, passport details and verification information are not shown in the general CRM directory or profile.</div>
    </>}
  </Drawer>;
};
export default GuestProfileModal;
